import { hoursToMinutes } from 'date-fns';
import { FC, ReactNode } from 'react';
import translations from '../pages/shifts/shiftReports/allShiftsReport.translations';
import strings from './././../pages/home/home.translations';

//Summary
export const displayHrsMinTime = (timeInMinutes: number) => {
  return `${Math.floor(Math.abs(timeInMinutes / 60)) + strings.common.hourShortHand}${
    Math.floor(Math.abs(timeInMinutes % 60)) + strings.common.minuteShortHand
  }`;
};

export const displayCost = (costInPounds: number) => {
  const roundedCost = Math.round(costInPounds * 100) / 100;
  return `£${Math.abs(roundedCost).toFixed(2)}`;
};

export const displayStaff = (totalStaff: number) => {
  return `${
    totalStaff + ' ' + (totalStaff === 1 ? strings.resourcesCostSummary.person : strings.resourcesCostSummary.people)
  }`;
};

//Shifts
export const getPayFromDuration = (durationInMinutes: number, hourlyRate: number) => {
  return (hourlyRate * durationInMinutes) / 60;
};

export const displayPay = (pay: number) => {
  return pay > 0 ? `£${pay.toFixed(2)}` : '-';
};

export const getPayToDisplay = (durationInMinutes: number, hourlyRate: number) => {
  return displayPay(getPayFromDuration(durationInMinutes, hourlyRate));
};

//Report
export const Total: FC<{children: ReactNode}> = ({ children }) => {
  return (
    <div className="flex justify-between text-base">
      <p>{translations.timeOverview.total}</p>
      {children}
    </div>
  );
};

export const formatReportTime = (totalTime: number) => {
  return `${Math.floor(totalTime)}${strings.common.hourShortHand}${hoursToMinutes(totalTime) % 60}${
    strings.common.minuteShortHand
  }`;
};
